import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "offer-verified__header" }
const _hoisted_2 = { class: "offer-verified__price-details-container" }
const _hoisted_3 = {
  key: 0,
  class: "offer-verified__price-detail-container"
}
const _hoisted_4 = {
  key: 2,
  class: "offer-price-operator"
}

import GroupedPriceInfo from '@lmt-rpb/Molecules/GroupedPriceInfo/GroupedPriceInfo.vue';

import OfferVerifiedHotelName from './OfferVerifiedHotelName.vue';
import type { MergedOfferItemData } from '@interfaces/offer';
import type { ClientType } from '@/interfaces/common';
import OfferVerifiedFooter from './OfferVerifiedFooter.vue';
import { computed } from 'vue';
import { getPriceTypeWording, getTotalPrice } from '@/js/utils/priceUtils';
import type { ClientCurrency } from '@global-js/constants';
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import PriceDetails from '@lmt-rpb/PriceDetails/PriceDetails.vue';
import { useOfferVerifiedInjection } from '../injectionProps';
import { gaSelectContentAttr } from 'src/utils/analytics';
import { useTranslations } from 'src/storybook/src/composables/translations';

interface Props {
	offerData: MergedOfferItemData;
	client?: ClientType;
	ibeCheckoutUrl?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedPriceDetails',
  props: {
    offerData: {},
    client: {},
    ibeCheckoutUrl: {}
  },
  emits: ['verify-offer'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { translate } = useTranslations();
const { isFetching, isVerified, isNotAvailable } = useOfferVerifiedInjection();
const buttonText = computed(() => (isNotAvailable.value ? translate('offer.notAvailable') : translate('offer.verifyOffer')));
const currency = computed((): ClientCurrency => props.offerData.CurrencyCode as ClientCurrency);
const onOfferVerify = () => {
	if (isFetching.value || isNotAvailable.value) {
		return;
	}
	emit('verify-offer');
};

const totalPrice = computed((): number => {
	// Ensure we have a valid price even if Pricing is undefined
	if (!props.offerData.Pricing) {
		return props.offerData.Price || 0;
	}
	return getTotalPrice(props.offerData.Pricing);
});

const perPersonText = computed((): string => {
	// Handle case where Pricing might be undefined
	if (!props.offerData.Pricing) {
		return '';
	}

	const price = props.offerData.Pricing.Single || { Amount: props.offerData.Price || 0 };
	return getPriceTypeWording({
		type: props.offerData?.Pricing?.Type,
		perPersonPrice: price.Converted ?? price.Amount,
		currency: currency.value,
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(OfferVerifiedHotelName, {
        name: _ctx.offerData.Name,
        category: _ctx.offerData.Category,
        client: _ctx.client
      }, null, 8 /* PROPS */, ["name", "category", "client"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(isVerified) && !_unref(isNotAvailable))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(PriceDetails, { "offer-data": _ctx.offerData }, null, 8 /* PROPS */, ["offer-data"])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.ibeCheckoutUrl && !_unref(isNotAvailable))
        ? (_openBlock(), _createBlock(OfferVerifiedFooter, {
            key: 1,
            "ibe-checkout-url": _ctx.ibeCheckoutUrl,
            "button-text": _unref(translate)('offer.addToCart')
          }, null, 8 /* PROPS */, ["ibe-checkout-url", "button-text"]))
        : _createCommentVNode("v-if", true),
      (!_unref(isVerified) || _unref(isNotAvailable))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(GroupedPriceInfo, {
              class: "offer-price-operator__price",
              currency: currency.value,
              "total-price": totalPrice.value,
              subtext: perPersonText.value
            }, null, 8 /* PROPS */, ["currency", "total-price", "subtext"]),
            _createVNode(RoundedButton, _mergeProps({ class: "offer-price-operator__check-button" }, _unref(gaSelectContentAttr)({ cId: 'offerlist_unverifiedoffer_button' }), {
              disabled: _unref(isNotAvailable),
              onClick: _withModifiers(onOfferVerify, ["prevent"])
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(buttonText.value), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["disabled"])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})